import React, { useState, useEffect, useRef } from "react";
import { useLocation, NavLink } from "react-router-dom";

function CompanyDropdownNavbar({ closeMobileMenu }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const location = useLocation();

  const CompanyPaths = [
    "/about-us",
    "/our-story",
    "/our-promises",
    "/exhibition",
    "/certification",
    "/catalogue",
    "/our-videos",
  ];

  const isCompanyRoute = CompanyPaths.includes(location.pathname);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <div className="nav-item dropdown" ref={dropdownRef}>
      <a
        href="#"
        className={`nav-link dropbtn ${isCompanyRoute ? "active" : ""}`}
        onClick={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
      >
        About
      </a>
      <div className={`dropdown-menu m-0 dropdown-content ${open ? "show" : ""}`}>
        <NavLink to="/about-us" className="dropdown-item"  onClick={closeMobileMenu}>
          ABOUT US
        </NavLink>
        {/* <NavLink to="/our-story" className="dropdown-item"  onClick={closeMobileMenu}>
          OUR STORY
        </NavLink> */}
        {/* <NavLink to="/our-promises" className="dropdown-item"  onClick={closeMobileMenu}>
          OUR PROMISES
        </NavLink> */}
        <NavLink to="/exhibition" className="dropdown-item"  onClick={closeMobileMenu}>
          EXHIBITION
        </NavLink>
        {/* <NavLink to="/certification" className="dropdown-item"  onClick={closeMobileMenu}>
          CERTIFICATION
        </NavLink> */}
        <NavLink to="/catalogue" className="dropdown-item"  onClick={closeMobileMenu}>
          CATALOGUE
        </NavLink>
        <NavLink to="/our-videos" className="dropdown-item"  onClick={closeMobileMenu}>
          VIDEOS
        </NavLink>
      </div>
    </div>
  );
}

export default CompanyDropdownNavbar;
